<template>
  <ul class="c-breadcrumbs-list c-breadcrumbs-list--alt">
    <li class="c-breadcrumbs-list__item" v-for="category in categoryCurrent" :key="category[0]">
      <a :href="category[1]" class="c-link c-link--theme-3" v-if="category[0] !== null">
        <span class="c-link__wrap">
          <span class="c-link__label">{{ category[0] }}</span>
          <span class="c-link__ico">
            <span class="o-ico o-ico--arrow-right o-ico--xs u-paint-green-1">
              <img alt="Right icon" src="/themes/transformer/img/icon/ico-right-open.svg" />
            </span>
          </span>
        </span>
      </a>
    </li>
    <!-- <li class="c-breadcrumbs-list__item">
      <a class="c-link c-link--theme-3" href="http://triny.local/" title="wróć do Strony Głównej">
        <span class="c-link__wrap">
          <span class="c-link__label">Główna</span>
          <span class="c-link__ico">
            <span class="o-ico o-ico--arrow-right o-ico--xs u-paint-green-1">
              <img alt="Right icon" src="/themes/transformer/img/icon/ico-right-open.svg" />
            </span>
          </span>
        </span>
      </a>
    </li> -->
  </ul>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  data: function () {
    return {
      title: Array
    }
  },
  props: {
    categoryCurrent: Array
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Algolia/components/breadcrumbs.vue